import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, Check } from "lucide-react";
import { CURRENCIES, useCurrency } from "../context/CurrencyContext";

export default function CurrencySwitcher({ dark = false }) {
  const { code, setCode } = useCurrency();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative" onMouseLeave={() => setOpen(false)}>
      <button
        data-testid="currency-switcher-button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 px-2.5 py-2 text-[10px] tracking-[0.25em] uppercase transition-colors duration-300 ${
          dark ? "text-ivory/70 hover:text-gold-light" : "text-ink/70 hover:text-gold-dark"
        }`}
        aria-label="Change currency"
      >
        {code}
        <ChevronDown size={12} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.ul
            data-testid="currency-menu"
            initial={{ opacity: 0, y: 8, rotateX: -20 }}
            animate={{ opacity: 1, y: 0, rotateX: 0 }}
            exit={{ opacity: 0, y: 8 }}
            transition={{ duration: 0.25 }}
            style={{ transformPerspective: 600 }}
            className="absolute right-0 top-full mt-1 w-36 bg-ivory border border-ink/10 shadow-[0_20px_50px_-20px_rgba(14,13,11,0.35)] py-1 z-50"
          >
            {Object.entries(CURRENCIES).map(([k, c]) => (
              <li key={k}>
                <button
                  data-testid={`currency-option-${k.toLowerCase()}`}
                  onClick={() => {
                    setCode(k);
                    setOpen(false);
                  }}
                  className="w-full flex items-center justify-between px-4 py-2.5 text-[10px] tracking-[0.2em] uppercase text-ink/70 hover:bg-champagne hover:text-ink transition-colors"
                >
                  {c.label}
                  {k === code && <Check size={12} className="text-gold-dark" />}
                </button>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
